import React from 'react';
import Blog from '../components/Blog/Blog';
const HealthBlogPage = () => {
    return (
        <Blog />
    )
}

export default HealthBlogPage;